interface Tag {
  text: string;
  count?: number;
}

interface TagCloudProps {
  tags: Tag[];
  variant?: 'green' | 'red' | 'blue' | 'purple' | 'orange' | 'gray';
}

const variantStyles: Record<string, string> = {
  green: 'bg-green-50 text-green-700 border-green-200',
  red: 'bg-red-50 text-red-700 border-red-200',
  blue: 'bg-blue-50 text-blue-700 border-blue-200',
  purple: 'bg-purple-50 text-purple-700 border-purple-200',
  orange: 'bg-orange-50 text-orange-700 border-orange-200',
  gray: 'bg-gray-50 text-gray-700 border-gray-200',
};

export default function TagCloud({ tags, variant = 'blue' }: TagCloudProps) {
  const style = variantStyles[variant];

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <span
          key={tag.text}
          className={`inline-flex items-center gap-1 text-sm font-medium px-3 py-1 rounded-full border ${style}`}
        >
          {tag.text}
          {tag.count && tag.count > 1 && (
            <span className="text-xs opacity-70">x{tag.count}</span>
          )}
        </span>
      ))}
    </div>
  );
}
